// extracted by mini-css-extract-plugin
module.exports = {"summary":"styles-module__summary___Slv9X"};